var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import { Icon } from '../Icon';
import { CalloutActions } from './CalloutActions';
import { CalloutContentComponent, CalloutElement, CalloutHeading, IconWrapper, LeftOfTopContainer, TopContainer, } from './elements';
import { usePropDeprecation } from '../../util';
var DEFAULT_LINE_LIMIT = 2;
export var Callout = React.forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b, heading = _a.heading, content = _a.content, 
    /**
    @deprecated buttonOne is replaced by primaryButton.
    */
    buttonOne = _a.buttonOne, 
    /**
    @deprecated buttonTwo is replaced by secondaryButton.
    */
    buttonTwo = _a.buttonTwo, _c = _a.primaryButton, primaryButton = _c === void 0 ? buttonOne : _c, _d = _a.secondaryButton, secondaryButton = _d === void 0 ? buttonTwo : _d, linkOne = _a.linkOne, compressConfig = _a.compressConfig, iconSrc = _a.iconSrc;
    usePropDeprecation({
        name: 'buttonOne',
        version: '3.0.0',
        alternative: 'primaryButton',
        value: buttonOne
    });
    usePropDeprecation({
        name: 'buttonTwo',
        version: '3.0.0',
        alternative: 'secondaryButton',
        value: buttonTwo
    });
    // Whether to use the Read more/less feature
    var compressionEnabled = !!(compressConfig === null || compressConfig === void 0 ? void 0 : compressConfig.compressableContent);
    var _e = useState(compressionEnabled && compressConfig.startCompressed !== false), isCompressed = _e[0], setIsCompressed = _e[1];
    return (React.createElement(InternalProvider, null,
        React.createElement(CalloutElement, { id: id, "aria-label": ariaLabel, className: className, ref: ref },
            React.createElement(TopContainer, null,
                React.createElement(LeftOfTopContainer, null,
                    React.createElement(CalloutHeading, null, heading),
                    React.createElement(CalloutContentComponent, { compressionEnabled: compressionEnabled, isCompressed: isCompressed, compressLineLimit: (compressConfig === null || compressConfig === void 0 ? void 0 : compressConfig.compressLineLimit) || DEFAULT_LINE_LIMIT, content: content })),
                iconSrc && (React.createElement(IconWrapper, null,
                    React.createElement(Icon, { src: iconSrc, size: "xxxlarge", fill: "currentColor" })))),
            React.createElement(CalloutActions, __assign({}, {
                primaryButton: primaryButton,
                secondaryButton: secondaryButton,
                linkOne: linkOne,
                compressionEnabled: compressionEnabled,
                isCompressed: isCompressed,
                setIsCompressed: setIsCompressed
            })))));
});
